function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_3772",
  "data-name": "Group 3772",
  transform: "translate(-168 -175)"
}, React.createElement("g", {
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  transform: "translate(168 175)",
  fill: "none",
  stroke: "#2ea733",
  strokeWidth: 6
}, React.createElement("circle", {
  cx: 39,
  cy: 39,
  r: 39,
  stroke: "none"
}), React.createElement("circle", {
  cx: 39,
  cy: 39,
  r: 36,
  fill: "none"
})), React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M1539.307,192.562l8.795,7.217,14.247-20.427",
  transform: "translate(-1344 25.918)",
  fill: "none",
  stroke: "#2ea733",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
}));

var SvgConfirmation = function SvgConfirmation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConfirmation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confirmation.7b65e09c.svg";
export { ForwardRef as ReactComponent };